(function () {
  function setHeaderHeight() {
    var el = document.querySelector('[data-bs-header]');
    if (!el) return;

    var section = el.closest('.shopify-section');
    if (!section) return;

    var h = Math.round(section.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight, { passive: true });
  } else {
    setHeaderHeight();
  }

  if ('ResizeObserver' in window) {
    var el = document.querySelector('[data-bs-header]');
    if (el) {
      var section = el.closest('.shopify-section') || el;
      var ro = new ResizeObserver(function () { setHeaderHeight(); });
      ro.observe(section);
    }
  } else {
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  /* ------------------------------------------------------------------------------------------------
     BS: Mobile Menu Drawer – Level-1 Links navigierbar machen (iOS-safe)
     - Level 1 ist im Drawer ein <button> (kein href)
     - URL wird aus Header-Links gemappt
     - Link (links) = Navigation, rechte Zone = Submenu
  ------------------------------------------------------------------------------------------------ */

  function bsBuildHeaderLinkMap() {
    var map = Object.create(null);
    var header = document.querySelector('header');
    if (!header) return map;

    var links = header.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) continue;

      var href = a.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) continue;

      if (!map[txt]) map[txt] = a.href;
    }
    return map;
  }

  var bsHeaderLinkMap = null;

  function bsGetClientX(ev) {
    // Pointer Events (best)
    if (typeof ev.clientX === 'number' && ev.clientX > 0) return ev.clientX;

    // Touch Events
    if (ev.changedTouches && ev.changedTouches[0] && typeof ev.changedTouches[0].clientX === 'number') {
      return ev.changedTouches[0].clientX;
    }
    if (ev.touches && ev.touches[0] && typeof ev.touches[0].clientX === 'number') {
      return ev.touches[0].clientX;
    }
    return null;
  }

  function bsHandleMenuTap(e) {
    var drawer = e.target.closest('#menu-drawer');
    if (!drawer) return;

    var toggleBtn = e.target.closest('button[data-panel-toggle][aria-controls^="menu-drawer-panel-"]');
    if (!toggleBtn) return;

    // Back-Button nicht anfassen
    if (toggleBtn.classList && toggleBtn.classList.contains('back-button')) return;

    // Nur Level-1 im Main Panel
    var mainPanel = toggleBtn.closest('#menu-drawer-panel-main');
    if (!mainPanel) return;

    var rect = toggleBtn.getBoundingClientRect();
    var clientX = bsGetClientX(e);
    if (!clientX) return;

    var clickX = clientX - rect.left;

    // Nur die letzten 44px rechts sind Toggle (Pfeilzone)
    var rightZone = 44;

    if (clickX >= (rect.width - rightZone)) {
      // Rechte Zone: Theme soll Submenu oeffnen
      return;
    }

    // Link-Zone: navigieren
    var label = (toggleBtn.textContent || '').replace(/\s+/g, ' ').trim();
    if (!label) return;

    if (!bsHeaderLinkMap) bsHeaderLinkMap = bsBuildHeaderLinkMap();

    var url = bsHeaderLinkMap[label];

    if (!url) {
      for (var k in bsHeaderLinkMap) {
        if (!Object.prototype.hasOwnProperty.call(bsHeaderLinkMap, k)) continue;
        if (k === label) { url = bsHeaderLinkMap[k]; break; }
        if (k.indexOf(label) !== -1 || label.indexOf(k) !== -1) { url = bsHeaderLinkMap[k]; break; }
      }
    }

    if (!url) return;

    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }

  // iOS: touchend ist zuverlaessiger als click. Pointerup deckt moderne Browser ab.
  document.addEventListener('touchend', bsHandleMenuTap, true);
  document.addEventListener('pointerup', bsHandleMenuTap, true);
  document.addEventListener('click', bsHandleMenuTap, true);

})();
